/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const ToggleLabel = styled.span`
  font-size: 0.925rem;
`;
